module.exports = __webpack_public_path__ + "static/scale-model-of-minneapolis-minnesota-1a90dddb98eec1392fef35efe30a3924.png";